var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0092 18.2324L20.4317 21.6557C20.54 22.5548 19.5758 23.1831 18.8067 22.7173L14.2675 20.0198C13.7692 20.0198 13.2817 19.9874 12.805 19.9224C13.6067 18.9799 14.0833 17.7881 14.0833 16.499C14.0833 13.4223 11.4183 10.9307 8.125 10.9307C6.86833 10.9307 5.70917 11.2882 4.745 11.9165C4.7125 11.6457 4.70166 11.3748 4.70166 11.0932C4.70166 6.16399 8.98083 2.1665 14.2675 2.1665C19.5542 2.1665 23.8333 6.16399 23.8333 11.0932C23.8333 14.0182 22.3275 16.6074 20.0092 18.2324Z",
    fill: "#1996A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0834 16.4989C14.0834 17.7881 13.6067 18.9798 12.805 19.9223C11.7325 21.2223 10.0317 22.0565 8.12502 22.0565L5.29752 23.7356C4.82085 24.0281 4.21418 23.6273 4.27918 23.0748L4.55002 20.9407C3.09835 19.9332 2.16669 18.3189 2.16669 16.4989C2.16669 14.5923 3.18503 12.9131 4.74503 11.9165C5.70919 11.2881 6.86835 10.9307 8.12502 10.9307C11.4184 10.9307 14.0834 13.4223 14.0834 16.4989Z",
    fill: "#FAB54E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.16d1d8078aa40a44fc76cabd87ca4f84.svg";
export { ForwardRef as ReactComponent };